function getCurrentJwt() {
    return localStorage.getItem("tokens");
}

function getCurrentRefreshToken() {
    return localStorage.getItem("refreshToken");
}

function setCurrentJwt(token) {
    localStorage.setItem("tokens", token);
}

function setCurrentRefreshToken(token) {
    localStorage.setItem("refreshToken", token);
}

function parseJwt(token) {
    if(!token) return;
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    // console.log("jsonPayload", JSON.parse(jsonPayload));
    return JSON.parse(jsonPayload);
};

export {
    parseJwt,
    getCurrentJwt,
    setCurrentJwt,
    getCurrentRefreshToken,
    setCurrentRefreshToken
}